/**
 * Projet: Gestion des stagiaires
 * Auteur : Tim Allemann
 * Date : 07.10.2022
 * Description : Configurations des requêtes API pour les types d'ARE
 * Fichier : typeJobSearchAssistanceServices.js
 **/

import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL
const CONTROLLER = '/api/typeJobSearchAssistances'

export default {
  getTypeJobSearchAssistances() {
    return axios.get(API_URL + CONTROLLER)
  },
  getTypeJobSearchAssistance(id) {
    return axios.get(API_URL + CONTROLLER + '/' + id)
  },
  postTypeJobSearchAssistance(typeJobSearchAssistance) {
    return axios.post(API_URL + CONTROLLER, typeJobSearchAssistance)
  },
  putTypeJobSearchAssistance(typeJobSearchAssistance) {
    return axios.put(
      API_URL +
        CONTROLLER +
        '/' +
        typeJobSearchAssistance.typeJobSearchAssistanceId,
      typeJobSearchAssistance
    )
  },
  deleteTypeJobSearchAssistance(typeJobSearchAssistanceId) {
    return axios.delete(API_URL + CONTROLLER + '/' + typeJobSearchAssistanceId)
  }
}
